import { Component, OnInit } from "@angular/core";
import { ICTDashboardDetailLvl3Model } from "src/app/model/ICTDashboardDetailLvl3Model";
import { ICTDashboardDetailModel } from "src/app/model/ICTDashboardDetailModel";
import { ICTDashboardModel } from "src/app/model/ICTDashboardModel";
import { ExcelExportService } from "src/app/services/excel-export.service";
import { HomeService } from "src/app/services/home.service";
import { registerLocaleData } from '@angular/common';
import localeIn from '@angular/common/locales/en-IN';

registerLocaleData(localeIn);

@Component({
  selector: "app-secure-ict-dashboard",
  templateUrl: "./ict-dashboard.component.html",
  styleUrls: ["./ict-dashboard.component.scss"],
})
export class ICTDashboardComponent implements OnInit {
  dashboardModel: ICTDashboardModel;
  dashboardDetailModel: ICTDashboardDetailModel;
  loaded1: boolean = false;
  loaded2: boolean = false;
  date: Date;
  selectedBoardId: number = null;
  selectedFinYear: string = null;
  selectedLotteryEventId: number = null;
  board: number = 0;
  year: string = "";
  lotteryEvent: number = 0;
  lotteries: {[key: number]: string} = {};

  lotteryCount: number = 0;
  categoryCount: number = 0;
  tenementSum: number = 0;
  applicationSum: number = 0;
  emdPaidApplicationSum: number = 0;
  winnerSum: number = 0;
  waitlistSum: number = 0;
  activatedWinnerSum: number = 0;
  activatedWaitlistSum: number = 0;
  operatedWinnerSum: number = 0;
  operatedWaitlistSum: number = 0;
  polSum: number = 0;
  allotmentSum: number = 0;
  possessionSum: number = 0;
  paymentReceivedSum: number = 0;
  

  constructor(private homeService: HomeService, private excelExportService: ExcelExportService) {

  }

  ngOnInit(): void { 

    console.log("Dashboard Loaded");

    this.date = null;
    this.loadData();
    this.loadDataDetail();
  }
  
  onChangeBoard(event: any) {
    this.selectedBoardId = +event.target.value;
    this.loadData();
    this.loadDataDetail();
  }
  
  onChangeFinYear(event: any) {
    this.selectedFinYear = event.target.value;
    this.loadData();
    this.loadDataDetail();
  }
  
  onChangeLottery(event: any) {
    this.selectedLotteryEventId = +event.target.value;
    this.loadData();
    this.loadDataDetail();
  }

  // loadData() {
  //   this.loaded1 = false;
  //   this.lotteries = {};
  //   this.homeService.fetchICTFilteredDashboard(
  //     this.selectedBoardId, this.selectedFinYear, this.selectedLotteryEventId
  //   ).subscribe(dashboard => {
  //     this.dashboardModel = dashboard;
  //     for(let lkey of Object.keys(this.dashboardModel.lotteries)) {
  //       let lotteryId = +lkey.split("#")[0];
  //       let boardId = +lkey.split("#")[1];
  //       let year = lkey.split("#")[2];
  //       if((this.selectedBoardId && this.selectedBoardId > 0 && this.selectedBoardId === boardId)) {
  //         if(this.selectedFinYear) {
  //           if(this.selectedFinYear !== "" && this.selectedFinYear === year) {
  //             this.lotteries[lotteryId] = this.dashboardModel.lotteries[lkey];
  //           }
  //         }
  //         else {
  //           this.lotteries[lotteryId] = this.dashboardModel.lotteries[lkey];
  //         }
  //       }
  //     }

  //     this.loaded1 = true;
  //     this.date = new Date();
  //   });
  // }

  loadData() {
  this.loaded1 = false;
  this.lotteries = {};

  console.log("API CALL STARTED");

  this.homeService.fetchICTFilteredDashboard(
    this.selectedBoardId,
    this.selectedFinYear,
    this.selectedLotteryEventId
  ).subscribe({

    next: (dashboard) => {

      console.log("API SUCCESS");
      console.log("dashboard => ", dashboard);

      this.dashboardModel = dashboard;

      console.log("dashboardModel => ", this.dashboardModel);

      this.loaded1 = true;
      this.date = new Date();
    },

    error: (err) => {

      console.log("API ERROR");
      console.log(err);

      this.loaded1 = true;
    }

  });
}

  loadDataDetail() {
    this.loaded2 = false;
    this.homeService.fetchICTDetailDashboard(
      this.selectedBoardId, this.selectedFinYear, this.selectedLotteryEventId
    )
    .subscribe(dashboardDetail => {
      this.dashboardDetailModel = dashboardDetail;
      this.loaded2 = true;
      this.calculateTotal(this.dashboardDetailModel);
    });
  }

  toggleExpand(row: any): void {
    row.expanded = !row.expanded;
  }

  refresh() {
    this.selectedBoardId = null;
    this.selectedFinYear = null;
    this.selectedLotteryEventId = null;
    this.board = 0;
    this.year = "";
    this.lotteryEvent = 0;
    this.ngOnInit();
  }

  boardClass(boardName?: string) {
    if (!boardName) return '';
    const name = boardName.toLowerCase();
    switch (name) {
      case 'mumbai': return 'mumbai';
      case 'konkan': return 'konkan';
      case 'pune': return 'pune';
      case 'chatrapati sambhajinagar': return 'aurangabad';
      case 'nashik': return 'nashik';
      case 'nagpur': return 'nagpur';
      default: return '';
    }
  }

  calculateTotal(dashboardDetailModel: ICTDashboardDetailModel) {
    this.resetTotal();
    for(let obj of dashboardDetailModel.lv11List) {
      this.lotteryCount+= obj.lotteryCount;
      this.categoryCount+= obj.categoryCount;
      this.tenementSum+= obj.effTenements;
      this.applicationSum+= obj.appCount;
      this.emdPaidApplicationSum+= obj.paidCount;
      this.winnerSum+= obj.winnerCount;
      this.waitlistSum+= obj.waitlistCount;
      this.activatedWinnerSum+= obj.actWinnerCount;
      this.activatedWaitlistSum+= obj.actWaitlistCount;
      this.operatedWinnerSum+= obj.winnerOperatedCount;
      this.operatedWaitlistSum+= obj.waitlistOperatedCount;
      this.polSum+= obj.polCount;
      this.allotmentSum+= obj.allotCount;
      this.possessionSum+= obj.possCount;
      this.paymentReceivedSum+= (obj.paidAmount + obj.emdAppFee);
    }
  }

  export() {
    if(this.dashboardDetailModel) {
      let lst: {[key: string]: string}[] = [];

      for(let lvl1 of this.dashboardDetailModel.lv11List) {
        for(let lvl2 of lvl1.lvl2List) {
          for(let lvl3 of lvl2.lvl3List) {
            lst.push({
              'Board': lvl3.boardName,
              'Lottery': lvl3.lotteryCode + ' - ' + lvl3.lotteryName,
              'Category': lvl3.categoryCode,
              'Tenements': lvl3.effTenements+'',
              'Applications': lvl3.appCount+'',
              'EMD Paid Applications': lvl3.paidCount+'',
              'Winners': lvl3.winnerCount+'',
              'Waitlists': lvl3.waitlistCount+'',
              'Activated Winners': lvl3.actWinnerCount+'',
              'Activated Waitlists': lvl3.actWaitlistCount+'',
              'Operated Winners': lvl3.winnerOperatedCount+'',
              'Operated Waitlists': lvl3.waitlistOperatedCount+'',
              'POL': lvl3.polCount+'',
              'Allotment': lvl3.allotCount+'',
              'Possession': lvl3.possCount+'',
              'Payment Received': (+lvl3.emdAppFee + +lvl3.paidAmount)+''

            });
          }
        }
      }

      this.excelExportService.exportExcel("ICT Dashboard Detail", 
        ["Board", "Lottery", "Category", "Tenements", "Applications", "EMD Paid Applications", 
          "Winners", "Waitlists", "Activated Winners", "Activated Waitlists", "Operated Winners",
          "Operated Waitlists", "POL", "Allotment", "Possession", "Payment Received"], 
        lst, "20,50,20,20,20,20,20,20,20,20,20,20,20,20,20,30", "User", new Date().toISOString(),
        );
    }
  }

  resetTotal() {
    this.lotteryCount = 0;
    this.categoryCount = 0;
    this.tenementSum = 0;
    this.applicationSum = 0;
    this.emdPaidApplicationSum = 0;
    this.winnerSum = 0;
    this.waitlistSum = 0;
    this.activatedWinnerSum = 0;
    this.activatedWaitlistSum = 0;
    this.operatedWinnerSum = 0;
    this.operatedWaitlistSum = 0;
    this.polSum = 0;
    this.allotmentSum = 0;
    this.possessionSum = 0;
    this.paymentReceivedSum = 0;
  }


}